import { Order } from '../context/DataContext';

/**
 * Why an order cannot go into a route, or null if it can.
 *
 * The customer's coordinates come from the WhatsApp location request. A
 * customer who never answered it has none, and an order without a drop point
 * cannot be optimized — the backend rejects the whole batch if one is in it,
 * so we keep those out of the selection in the first place.
 *
 * The backend re-checks this (and the shop side, which we cannot see here)
 * in POST /api/route/validate; this is the instant local half.
 */
export const routeBlocker = (order: Order): string | null => {
  const { latitude, longitude } = order;
  if (latitude == null || longitude == null) {
    return 'Customer has not shared their delivery location';
  }
  if (Number.isNaN(Number(latitude)) || Number.isNaN(Number(longitude))) {
    return 'Customer location is not a valid coordinate';
  }
  return null;
};

export const isRoutable = (order: Order): boolean => routeBlocker(order) === null;
